import { HANDLE_PRODUCT, RESET } from '../actions';
import moment from "moment";

const initialState = {  
    userProduct: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case HANDLE_PRODUCT:
      return {
        ...state,
        ...action.data
      };
    case RESET:
        return initialState;
    default:
      return state;
  } 
}
